<template>
  <b-card style="margin-top: 150px">
    <h1 class="text-center">
      Tienes {{ recolecciones.length }}
      {{ recolecciones.length === 1 ? "recolección" : "recolecciones" }} por
      sincronizar
    </h1>

    <b-row class="mt-5">
      <b-col class="text-center">
        <b-button
          :disabled="disableBtn || recolecciones.length <= 0"
          @click="store()"
          variant="success mt-5 h2"
        >
          Sincronizar
        </b-button>
        <b-spinner
          v-if="disableBtn"
          variant="success"
          class="h2 ml-3"
          style="vertical-align: text-top"
          label="Spinning"
        ></b-spinner>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
//import BusEvent from "../../../busEvent";

import ApiService from "../../../core/services/api.service";
//import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from "vuex";

export default {
  name: "UsersP",

  data() {
    return {
      disableBtn: false,
      //localAddress : '//appagricactus.xyz'
      // localAddress : '//localhost:3000/api/v1'
    };
  },

  methods: {
    randomString(length) {
      const chars =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    async store() {
      let totalErrors = 0;
      try {
        this.disableBtn = true;
        const response = await ApiService.post(
          "recoleccion",
          this.recolecciones
        );

        if (!response.data.success) {
          throw new Error(
            "Hubo un error al intentar sincronizar las recolecciones, por favor intente de nuevo."
          );
        }
        this.$store.dispatch("resetDb")
        this.$toasted.show(
          `Se sincronizaron las recolecciones exitosamente con ${totalErrors} errores.`,
          {
            duration: 1500,
            type: "success",
          }
        );
      } catch (err) {
        let message = `Hubo un error al sincronizar: ${err.message}`;
        const isNetworkError = err.message.includes("Network");
        if (isNetworkError) {
          message = "No tienes conexión a la red.";
        }
        this.$toasted.show(message, {
          duration: 1500,
          type: "error",
        });
      } finally {
        this.disableBtn = false;
      }

      /*    axios.get( self.localAddress + '/recoleccion/try')
      .then(function (response) {
        if(response.data.success != undefined && response.data.success){
         
            axios.post( self.localAddress + '/recoleccion',recolecciones)
              
            .then(done => {
              console.log(done)
              self.disableBtn = false
              self.$toasted.show("Se sincronizaron las recolecciones exitosamente con " + errors + ' errores.', {
                duration: 1500,
                type: "success"
              });
             
              self.$store.dispatch("resetDb")
            }).catch(err => {
               self.disableBtn = false
               console.log(err)
               self.$toasted.show("Hubo error al sincronizar.", {
                  duration: 1500,
                  type: "error"
               });
            })
        }else{
          self.$toasted.show("No tienes conección a la red.", {
            duration: 1500,
            type: "error"
          });
          self.disableBtn = false
        }
      })
      .catch(function (error) {
        console.log(error);
        self.$toasted.show("No tienes conección a la red.", {
          duration: 1500,
          type: "error"
        });
        self.disableBtn = false
      }) */
    },
  },
  mounted() {},
  computed: {
    ...mapState({
      recolecciones: (state) => state.asistencias.recolecciones,
    }),
  },
  destroyed() {},
};
</script>

<style>
.custom-card {
  background-color: #ffffff;
  margin: 5px 5px 8px 5px;
  padding: 5px;
  border-radius: 4px;
  border-color: #444444;
  font-size: 14px;
}

.option-container {
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 10px 5px;
}
.input-radio-l {
  margin: 5px;
  align-self: center;
}

.input-radio {
  margin: 5px;
  padding-top: 8px;
  align-self: center;
  height: 20px;
  width: 20px;
  vertical-align: middle;
}
</style>
